import { getUserTeams } from 'team/apis/teamApi';

/**
 * Clear authentication data from localStorage
 */
export const clearAuthData = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
  localStorage.removeItem('userState');
  localStorage.removeItem('cardState');
  localStorage.removeItem('cardData');
  localStorage.removeItem('cardId');
  localStorage.removeItem('contactLinkUUID');
  localStorage.removeItem('tempLinksFetched');
  sessionStorage.clear();
};

/**
 * Check if an error is an authentication error (401)
 * @param {Error} error - Error object
 * @returns {boolean} True if error is 401
 */
export const isAuthenticationError = (error) => {
  return error?.response?.status === 401 || error?.status === 401;
};

/**
 * Check if an error is an authorization error (403)
 * @param {Error} error - Error object
 * @returns {boolean} True if error is 403
 */
export const isAuthorizationError = (error) => {
  return error?.response?.status === 403 || error?.status === 403;
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user has auth token
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  const authUser = localStorage.getItem('authUser');
  return !!(token && authUser);
};

/**
 * Determine the redirect path after login based on user's plan and role
 * @param {Object} user - User object from auth
 * @param {string} idToken - Authentication token
 * @returns {Promise<string>} Redirect path ('/team' or '/dashboard')
 */
export const getLoginRedirectPath = async (user, idToken) => {
  // If user doesn't have team plan, go to dashboard
  if (!user || user.plan !== 'team') {
    return '/dashboard';
  }

  // If user has team plan, check if they are a team admin
  try {
    const teamsResponse = await getUserTeams();
    const teams = teamsResponse?.teams || teamsResponse || [];

    // Check if user is admin in any team
    const isTeamAdmin = teams.some(team => {
      const membership = team.membershipInfo || team;
      return membership.role === 'admin';
    });

    // If user is team admin, redirect to /team, otherwise /dashboard
    return isTeamAdmin ? '/team' : '/dashboard';
  } catch (error) {
    console.error('Error checking team admin status:', error);
    // On error, default to dashboard
    return '/dashboard';
  }
};
